import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'sbnb-connect-booking-widget',
  templateUrl: './connect-booking-widget.component.html',
  styleUrls: ['./connect-booking-widget.component.scss'],
})
export class ConnectBookingWidgetComponent implements OnInit {
  bookingComRedirect: string =
    'https://admin.booking.com/?groups_redirect=%2Fhotel%2Fhoteladmin%2Fextranet_ng%2Fmanage%2Fchannel-manager%2Fwidget.html?provider_id=1484';

  constructor(private readonly router: Router) { }

  ngOnInit(): void { }

  openPopup() {
    const url = this.bookingComRedirect;
    const width = window.innerWidth * 0.75; // 75% of window width
    const height = window.innerHeight * 0.75; // 75% of window height
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;

    const popup = window.open(url, 'Popup', `width=${width},height=${height},top=${top},left=${left}`);
    if (popup) {
      popup.focus(); // Focus the popup if it successfully opened
    }

    this.progress();
  }

  progress() {
    this.router.navigate(['/accounts/new/booking/property-ids']);
  }
}
